module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['p-carousel p-component', {
      'p-carousel-vertical': _vm.isVertical(),
      'p-carousel-horizontal': !_vm.isVertical()
    }],
    attrs: {
      "id": _vm.id
    }
  }, [(_vm.$scopedSlots.header) ? _c('div', {
    staticClass: "p-carousel-header"
  }, [_vm._t("header")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.contentClasses
  }, [_c('div', {
    class: _vm.containerClasses
  }, [_c('button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    class: ['p-carousel-prev p-link', {
      'p-disabled': _vm.backwardIsDisabled
    }],
    attrs: {
      "disabled": _vm.backwardIsDisabled,
      "type": "button"
    },
    on: {
      "click": _vm.navBackward
    }
  }, [_c('span', {
    class: ['p-carousel-prev-icon pi', {
      'pi-chevron-left': !_vm.isVertical(),
      'pi-chevron-up': _vm.isVertical()
    }]
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-carousel-items-content",
    style: ([{
      'height': _vm.isVertical() ? _vm.verticalViewPortHeight : 'auto'
    }])
  }, [_c('div', {
    ref: "itemsContainer",
    staticClass: "p-carousel-items-container",
    on: {
      "transitionend": _vm.onTransitionEnd,
      "touchend": _vm.onTouchEnd,
      "touchstart": _vm.onTouchStart,
      "touchmove": _vm.onTouchMove
    }
  }, [(_vm.isCircular()) ? _vm._l((_vm.value.slice(-1 * _vm.d_numVisible)), function(item, index) {
    return _c('div', {
      key: index + '_scloned',
      class: ['p-carousel-item p-carousel-item-cloned',
        {
          'p-carousel-item-active': (_vm.totalShiftedItems * -1) === (_vm.value.length + _vm.d_numVisible),
          'p-carousel-item-start': 0 === index,
          'p-carousel-item-end': _vm.value.slice(-1 * _vm.d_numVisible).length - 1 === index
        }
      ]
    }, [_vm._t("item", null, {
      "data": item,
      "index": index
    })], 2)
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.value), function(item, index) {
    return _c('div', {
      key: index,
      class: ['p-carousel-item',
        {
          'p-carousel-item-active': _vm.firstIndex() <= index && _vm.lastIndex() >= index,
          'p-carousel-item-start': _vm.firstIndex() === index,
          'p-carousel-item-end': _vm.lastIndex() === index
        }
      ]
    }, [_vm._t("item", null, {
      "data": item,
      "index": index
    })], 2)
  }), _vm._v(" "), (_vm.isCircular()) ? _vm._l((_vm.value.slice(0, _vm.d_numVisible)), function(item, index) {
    return _c('div', {
      key: index + '_fcloned',
      class: ['p-carousel-item p-carousel-item-cloned',
        {
          'p-carousel-item-active': _vm.totalShiftedItems === 0,
          'p-carousel-item-start': 0 === index,
          'p-carousel-item-end': _vm.value.slice(0, _vm.d_numVisible).length - 1 === index
        }
      ]
    }, [_vm._t("item", null, {
      "data": item,
      "index": index
    })], 2)
  }) : _vm._e()], 2)]), _vm._v(" "), _c('button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    class: ['p-carousel-next p-link', {
      'p-disabled': _vm.forwardIsDisabled
    }],
    attrs: {
      "disabled": _vm.forwardIsDisabled,
      "type": "button"
    },
    on: {
      "click": _vm.navForward
    }
  }, [_c('span', {
    class: ['p-carousel-prev-icon pi', {
      'pi-chevron-right': !_vm.isVertical(),
      'pi-chevron-down': _vm.isVertical()
    }]
  })])]), _vm._v(" "), _c('ul', {
    class: _vm.indicatorsContentClasses
  }, _vm._l((_vm.totalIndicators), function(indicator, i) {
    return _c('li', {
      key: 'p-carousel-indicator-' + i,
      class: ['p-carousel-indicator', {
        'p-highlight': _vm.d_page === i
      }]
    }, [_c('button', {
      staticClass: "p-link",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.onIndicatorClick($event, i)
        }
      }
    })])
  }), 0)]), _vm._v(" "), (_vm.$scopedSlots.footer) ? _c('div', {
    staticClass: "p-carousel-footer"
  }, [_vm._t("footer")], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9abb8666"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/primevue/carousel/Carousel.vue
// module id = 2369
// module chunks = 0